const classifyRepeaterEntryMode = require('./classifyRepeaterEntryMode');

module.exports = {
   ...classifyRepeaterEntryMode.malformedReasonCodes,
   LIST_REPEATER_BINDING_MISSING: 'LIST_REPEATER_BINDING_MISSING',
   LIST_REPEATER_BINDING_MALFORMED: 'LIST_REPEATER_BINDING_MALFORMED',
   LIST_REPEATER_DATASOURCE_NOT_FOUND: 'LIST_REPEATER_DATASOURCE_NOT_FOUND',
   LIST_REPEATER_DATASOURCE_INACCESSIBLE: 'LIST_REPEATER_DATASOURCE_INACCESSIBLE',
   LIST_REPEATER_DATASOURCE_RESOLUTION_FAILED: 'LIST_REPEATER_DATASOURCE_RESOLUTION_FAILED'
};
